function FinalsLines() {
  return (
    <div className="lines-container">
      <div className="line-container">
        <div className="arrow"></div>
      </div>
    </div>
  );
}

export default FinalsLines;
